import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { CapacitorHttp, HttpResponse } from '@capacitor/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ApiService {

	constructor(
		public http: HttpClient,
//		public http_mobile: HTTP,
	) {
	}

	post(api: string, body: any, token: any = null) : Observable<object> {

		//console.log("API");

        //Mobile
        //if (window['cordova']) {
        if ((window as any).cordova) {

			//console.log("MOBILE");
	
			var link = environment.domain_api_emu + api;

			/**
			 * Set server trust mode, being one of the following values:
			 * default: default SSL trustship and hostname verification handling using system's CA certs;
			 * legacy: use legacy default behavior (< 2.0.3), excluding user installed CA certs (only for Android);
			 * nocheck: disable SSL certificate checking and hostname verification, trusting all certs (meant to be used only for testing purposes);
			 * pinned: trust only provided certificates;
			 * @see https://github.com/silkimen/cordova-plugin-advanced-http#setservertrustmode
			 * @param {string} mode server trust mode
			 */
			if (environment.server_trust) {
//				this.http_mobile.setServerTrustMode("nocheck");
			} else {
//				this.http_mobile.setServerTrustMode("pinned");
			}

			//console.log("POST", link, body);

			let header_params: any;
			header_params = {
				"X-Requested-With": "XMLHttpRequest", 
				"Content-Type": "application/json"
			};
			if (token) {
				header_params = {
					"X-Requested-With": "XMLHttpRequest", 
					"Content-Type": "application/json",
					"Authorization": "Bearer " + token
				};
			}

/* 			return new Observable((observer) => {
				this.http_mobile.post(
					link, 
					body,
					{headers: header_params}
				//).then(data => {console.log(data.data); observer.next(JSON.parse(data.data))})
				).then(data => observer.next(JSON.parse(data.data)))
				.catch(err => console.error("Error!!!", err))
			});
 */

			const options = {
				url: link,
				headers: header_params,
				data: body,
			};
			
			return new Observable((observer) => {
				CapacitorHttp.post(options).then(data => observer.next(data.data)).catch(err => console.error("Error!!!", err))
			});

		//Browser
		} else {

			var link = environment.domain_api + api;

			//console.log("POST", link, body);

			let header_params: HttpHeaders = new HttpHeaders();
			header_params = header_params.append('X-Requested-With','XMLHttpRequest');
			header_params = header_params.append('processData','false');
			header_params = header_params.append('contentType','false');
			if (token) {
				header_params = header_params.append('Authorization','Bearer ' + token);
			}

			return this.http.post(
					link,
					body,
					{headers: header_params}
				).pipe(res => res);

		}

	}

    get(api: string, body: any, token: any = null) : Observable<object> {
        
        //Mobile
        //if (window['cordova']) {
        if ((window as any).cordova) {

			var link = environment.domain_api_emu + api;

			/**
			 * Set server trust mode, being one of the following values:
			 * default: default SSL trustship and hostname verification handling using system's CA certs;
			 * legacy: use legacy default behavior (< 2.0.3), excluding user installed CA certs (only for Android);
			 * nocheck: disable SSL certificate checking and hostname verification, trusting all certs (meant to be used only for testing purposes);
			 * pinned: trust only provided certificates;
			 * @see https://github.com/silkimen/cordova-plugin-advanced-http#setservertrustmode
			 * @param {string} mode server trust mode
			 */
			if (environment.server_trust) {
//				this.http_mobile.setServerTrustMode("nocheck");
			} else {
//				this.http_mobile.setServerTrustMode("pinned");
			}

			//console.log("GET", link, body);


			let header_params: any;
			header_params = {
				"X-Requested-With": "XMLHttpRequest", 
				"Content-Type": "application/json"
			};
			if (token) {
				header_params = {
					"X-Requested-With": "XMLHttpRequest", 
					"Content-Type": "application/json",
					"Authorization": "Bearer " + token
				};
			}

//            return new Observable((observer) => {
//				this.http_mobile.get(
//					link, 
//					body,
//					{"X-Requested-With": "XMLHttpRequest"}
//				).then(data => observer.next(JSON.parse(data.data)))
//				.catch(err => console.error("Error!!!", err))
//			});

			const options = {
				url: link,
				headers: header_params,
				params: body,
			};
			
			return new Observable((observer) => {
				CapacitorHttp.get(options).then(data => observer.next(data.data)).catch(err => console.error("Error!!!", err))
			});


		//Browser
		} else {

			var link = environment.domain_api + api;

			//console.log("GET", link, body);

			let header_params: HttpHeaders = new HttpHeaders();
			header_params = header_params.append('X-Requested-With','XMLHttpRequest');
			if (token) {
				header_params = header_params.append('Authorization','Bearer ' + token);
			}

            return this.http.get(
                    link,
					{headers: header_params, params: body}
//                    {headers: {"X-Requested-With": "XMLHttpRequest"}, params: body}
                )
                .pipe(res => res);
        }
    }
        
}